module.exports = __webpack_public_path__ + "img/helmet-yellow.c6fe8d96.png";